<template>
  <div>
    <group-card title="Manual Assessment Required" icon="rule">
      <template slot="actions">
        <loading-icon-text-button
          v-if="refreshable"
          class="md-primary md-sm"
          @click="refreshAssessment"
          tooltip="Run again"
          icon="refresh"
          :loading="isRefreshing">
            UPDATE ASSESSMENT NOW
        </loading-icon-text-button>
      </template>
     
      <div class="outcome-table md-layout md-size-100">
        <template v-if="isRefreshing" >
          <div class="md-layout md-alignment-center-center md-size-50">
            <md-card class="waiting-assessment-card">
              <md-card-header-text>
                <div class="md-title waiting-assessment-title">Fetching Assessment...</div>
              </md-card-header-text>
              <md-card-content class="waiting-assessment-content">
                <img :src="img_src" />
                <p>Please wait whilst we are fetching the assessment.</p>
              </md-card-content>
            </md-card>
          </div>
        </template>
        <template v-else>
          <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-20">
            <traffic-light-card
              title="RAM Assessment"
              status="neutral"
              :same-line="false"
            >
              <div class="engine_items">
                <li>Manual Assessment Required</li>
              </div>
            </traffic-light-card>
          </div>
        </template>
        <template v-if="show_capacity_card">
          <div class="md-layout-item md-medium-size-33 md-small-size-50 md-size-20">
            <traffic-light-card
              :title="zinkCapacityCard.card.title"
              :status="zinkCapacityCard.card.status"
              :same-line="false"
            >
              <div class="engine_items">
                <li :status="zinkCapacityCard.note.status">
                  {{ zinkCapacityCard.note.description }}
                </li>
              </div>
            </traffic-light-card>
          </div>
        </template>
      </div>
    </group-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import LoadingIconButton from "@/components/LoadingIconButton.vue";
import { NoteView } from "@/components";
import TrafficLightCard from "../Cards/TrafficLightCard";
import LoadingIconTextButton from "@/components/LoadingIconTextButton";

let img_src = require("@/assets/img/zink-logo-loading-animation-color.gif");

export default {
  components: {
    TrafficLightCard,
    LoadingIconButton,
    ...ValidatedInputs,
    GroupCard,
    NoteView,
    LoadingIconTextButton,
  },
  props: {
    value: {
      type: Object,
    },
    refreshable: {
      type: Boolean,
      default: false,
    },
    zinkCapacityCard: {
      type: Object,
      default: () => {
        return {
          card: {
            title: 'Zink Capacity Rules',
            status: 'good'
          },
          note: {
            description: '',
            status: 'good'
          }
        }
      }
    },
    assetType: {
      type: String,
      default: "Vehicle",
    }
  },
  data() {
    return {
      img_src,
      isRefreshing: false,
    };
  },
  computed: {
    ...mapGetters([
      "is_ram_authorized"
    ]),
    status_message() {
      if (this.isRefreshing) {
        return 'Loading...';
      }
      switch (this.zinkCapacityCard.card.status) {
        case "good":
          break;
        case "neutral":
          return "Warning";
        case "bad":
          return "Manual Assessment Required";
      }
    },
    show_capacity_card () {
      if (this.zinkCapacityCard.card.status == 'good' || this.isRefreshing) {
        return false;
      }
      return true;
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,
    async refreshAssessment() { // refresh button
      this.isRefreshing = true;
      if (this.is_ram_authorized) {
        this.refreshRamAssessment();
      }
    },
    async refreshRamAssessment() {
      this.$emit("setRamError", false);
      this.$emit("fetchMlAssessment");
      this.isRefreshing = false;
    },
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme.scss";

.good {
  color: $color-good !important;
}
.neutral {
  color: $color-neutral !important;
}
.bad {
  color: $color-bad !important;
}
.information {
  color: $color-information !important;
}

.greyed {
  color: $color-grey !important;
}

.outcome-table {
  & td {
    padding-top: 10px;
    font-weight: bold;
  }

  & td .note {
    font-weight: normal;
  }

  & td:first-child {
    width: 50px;
  }
}

.waiting-assessment-card{
  background: $ausloans-blue-hover !important;
  color: $color-text-on-dark !important;
  width: auto;

  .waiting-assessment-title {
    padding-top: 20px;
  }

  .waiting-assessment-content {
    display: flex;
    flex-direction: column;

    & img {
      width: 100px;
      align-self: center;
    }

    & p {
      margin-top: 16px;
    }
  }
}
</style>
